module.exports = __webpack_public_path__ + "static/media/idVerify-desktop.d0b5d20f.png";